import type { Path } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FieldInput } from '@/components/form/field-input';
import { FieldSelect } from '@/components/form/field-select';
import { FloorOptions } from '@/features/estates-property/utils/floorOptions';

import type { EstateValidationSchemaType } from '../../schemas/estate-validation';

export const AreasForm = () => {
  const { t } = useTranslation();

  const methods = useFormContext<EstateValidationSchemaType>();

  const propertyType = methods.watch('estateDetails.propertyType');

  return (
    <div className="space-y-2">
      <h4 className="text-md font-bold">{t('areasAndRooms')}</h4>
      <FieldInput
        methods={methods}
        name="estateAreasRooms.livingArea"
        label={t('livingArea')}
        inputProps={{ type: 'number' }}
      />
      {propertyType === 'house' ? (
        <FieldInput
          methods={methods}
          name={'estateAreasRooms.plotArea' as Path<EstateValidationSchemaType>}
          label={t('plotArea')}
          inputProps={{ type: 'number' }}
        />
      ) : null}
      <FieldInput
        methods={methods}
        name="estateAreasRooms.totalNumberOfRooms"
        label={t('totalNumberOfRooms')}
        inputProps={{ type: 'number', decimals: 1, step: 0.1 }}
      />
      <FieldInput
        methods={methods}
        name="estateAreasRooms.numberOfBathrooms"
        label={t('numberOfBathrooms')}
        inputProps={{ type: 'number' }}
      />
      <FieldInput
        methods={methods}
        name="estateAreasRooms.balconyArea"
        label={t('balconyArea')}
        inputProps={{ type: 'number', decimals: 2, step: 0.01 }}
      />
      <FieldInput
        methods={methods}
        name="estateAreasRooms.gardenArea"
        label={t('gardenArea')}
        inputProps={{ type: 'number', decimals: 2, step: 0.01 }}
      />
      {propertyType === 'apartment' ? (
        <>
          <FieldSelect
            methods={methods}
            name="estateAreasRooms.floor"
            label={t('floor')}
            type="number"
            options={FloorOptions}
          />
          <FieldSelect
            methods={methods}
            name="estateAreasRooms.hasElevator"
            label={t('hasElevator')}
            type="number"
            options={[
              {
                id: '1',
                title: t('yes'),
              },
              {
                id: '0',
                title: t('no'),
              },
            ]}
          />
        </>
      ) : null}
    </div>
  );
};
